import React, { useEffect, useState } from 'react';
import { Button } from 'selfly-ui-react/dist/components/';

import InnerSpinner from '../Loading/InnerSpinner';

import { JOKI } from '../../JOKI';

export default function CrudNewContainer({ crudState, crudDispatch, ...props }) {
    const [fullItem, setFullItem] = useState('LOADING');
    const [saving, setSaving] = useState(false);

    const [formIsValid, setFormIsValid] = useState(false);

    useEffect(() => {
        async function getFullCrudItem(item) {
            const results = await JOKI.ask({
                from: 'React:CrudNewContainer',
                to: crudState.serviceId,
                key: 'getEmptyCrudItem',
                body: item,
            });

            if (results && results[crudState.serviceId]) {
                setFullItem(results[crudState.serviceId]);
            }
        }

        getFullCrudItem(crudState.item);
        // eslint-disable-next-line
    }, []);

    function onCancel() {
        crudDispatch({ type: crudState.backTo || 'list' });
    }

    function onSave() {
        setSaving(true);
        JOKI.trigger({
            from: 'React:CrudNewContainer',
            to: crudState.serviceId,
            key: 'crudNewItem',
            body: fullItem,
        });

        crudDispatch({ type: crudState.backTo || 'list' });
    }

    function changeData(data, dataIsValid = null) {
        if (fullItem !== null) {
            setFullItem(data);
            if (dataIsValid !== null) {
                setFormIsValid(dataIsValid);
            }
        }
    }

    const CrudForm = crudState.form || null;

    const saveIsDisabled = !formIsValid || saving === true;

    return (
        <>
            <div className="page-header-title-row">
                <h3>{crudState.title}: New</h3>
                {fullItem !== 'LOADING' && (
                    <div className="long-buttons">
                        <Button icon="cancel" onClick={onCancel}>
                            Cancel
                        </Button>
                        <Button icon="save" type="positive" onClick={onSave} disabled={saveIsDisabled}>
                            Save
                        </Button>
                    </div>
                )}
            </div>
            <div className="view-body">
                <div className="body-list crud-container">
                    {fullItem === 'LOADING' && <InnerSpinner />}
                    {fullItem !== 'LOADING' && CrudForm !== null && <CrudForm item={fullItem} onChange={changeData} crudState={crudState} />}
                </div>
            </div>
        </>
    );
}
